export class RestoreInAccountSnapshotRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreInAccountSnapshotRequest.attributeTypeMap;
    }
    constructor() {
    }
}
